import { ObjectField, Test, TestType } from '../../parser/models/all.js';
import { getFunctionTestCases } from '../../parser/utils/testCaseUtils.js';
import { PreProcessContext } from '../models/preProcessContext.js';

/**
 * Processor for identifying tests defined as an array where the last element is the test function.
 * This is an alternative way to define parameterized tests without decorators.
 * 
 * @param field - The object field containing the array.
 * @param index - Field index in the collection.
 * @param context - The pre-processing context.
 * @returns True if the field was processed as a function with cases array.
 */
export function processFunctionWithCasesArray(field: ObjectField, index: number, context: PreProcessContext): boolean {
  let { name, value } = field;

  if (field.isFunctionWithCases) {
    const testCases = getFunctionTestCases(field.value);

    context.tests.push(
      new Test(
        field.groupName,
        name,
        value[value.length - 1],
        new TestType(TestType.FUNCTION_WITH_CASES),
        testCases,
        // only expression
        ""
      )
    );

    return true;
  }

  return false;
}
